import React from 'react';
import { motion } from 'framer-motion';
import sobreAFoco from '../../assets/images/SobreaFoco.png';
import { WHATSAPP_LINKS } from '../../config/whatsapp';

const About = () => {
  return (
    <section id="sobre" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Sobre a FocoSeg</h2>
          <div className="w-20 h-1 bg-focoseg-green mx-auto"></div>
        </div>
        
        <div className="flex flex-col md:flex-row items-center">
          <motion.div 
            className="md:w-1/2 mb-8 md:mb-0"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <img 
              src={sobreAFoco} 
              alt="Sobre a FocoSeg" 
              className="rounded-lg shadow-xl max-w-full h-auto"
            />
          </motion.div>
          
          <motion.div 
            className="md:w-1/2 md:pl-12"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Nossa História</h3>
            <p className="text-gray-600 mb-4">
              A FocoSeg nasceu da necessidade de oferecer soluções completas e integradas em segurança do trabalho e saúde ocupacional. Com mais de 5 anos de experiência, nos tornamos referência no mercado, atendendo empresas de diversos segmentos.
            </p>
            <p className="text-gray-600 mb-4">
              Nossa missão é garantir a segurança e saúde dos trabalhadores, contribuindo para um ambiente de trabalho mais seguro e produtivo, além de assegurar a conformidade legal das empresas.
            </p>
            <p className="text-gray-600 mb-6">
              Contamos com uma equipe multidisciplinar de profissionais altamente qualificados, incluindo médicos do trabalho, engenheiros de segurança, técnicos de segurança, enfermeiros e outros especialistas.
            </p>
            <div className="flex space-x-4">
              <a 
                href={WHATSAPP_LINKS.focoseg} 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-focoseg-green hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-lg transition duration-300"
              >
                Entre em Contato
              </a>
              <a 
                href="#servicos" 
                className="inline-block bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-6 rounded-lg transition duration-300"
              >
                Nossos Serviços
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;